import { operations } from "@/api/operations/useOperationsQuery";
import { Main } from "@/features/standard/Main";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { OperationsGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { OperationDetailHeader } from "../header/operationDetailHeader";

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});
interface OperationDetailFormProps {
  operationCode: string | undefined;
}
export const OperationDetailForm = ({ operationCode }: OperationDetailFormProps) => {
  const { data: operation } = useQuery(
    operations.get({
      query: {
        $and: [{ code: operationCode }],
      },
      populate: ["location"],
    }),
  );
  const operationData = operation?.data?.rows?.[0] as OperationsGet200ResponseRowsInner;

  return (
    <Detail.Container>
      <Detail.Wrapper>
        <Detail.Content>
          <OperationDetailHeader operationData={operationData} />
        </Detail.Content>
      </Detail.Wrapper>
    </Detail.Container>
  );
};
